import { render, staticRenderFns } from "./MetricRecordList.vue?vue&type=template&id=2496ac9d"
import script from "./MetricRecordList.vue?vue&type=script&lang=js"
export * from "./MetricRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports